/* eslint-disable */
import axios from "axios";
import store from "@/store";
import VPagination from "@hennge/vue3-pagination";
import KriDetailsModal from "./KriDetailsModal.vue";
import manageKRIModal from "./ManageKRIModal.vue";

export default {
    name: "KriRegistry",
    components: {
        VPagination,
        KriDetailsModal,
        manageKRIModal,
    },

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            rollsprivilages: "",
            token: "",
            studyId: "",
            loading: false,
            kriList: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            totalPages: 1,

            // Filters — match the API query param names exactly
            searchField: {
                kriId: "",
                ctqId: "",
                riskId: "",
            },

            selectedKriItem: null,
            showKriDetailsModal: false,

            openCreateRiskModal: false,
            riskEditData: null,
        };
    },

    async mounted() {
        this._studyIdChangedHandler = async () => {
            this.rollsprivilages = store.getters.getRolesprivilegeData;
            this.studyId = store.getters.getStudyIs;
            this.token = store.getters.getIdToken;
            this.currentPage = 1;
            await this.fetchKriDetails();
        };
        window.addEventListener("studyIdChanged", this._studyIdChangedHandler);
        this.rollsprivilages = store.getters.getRolesprivilegeData;
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        this.fetchKriDetails();
    },

    beforeUnmount() {
        window.removeEventListener("studyIdChanged", this._studyIdChangedHandler);
    },

    methods: {
        async fetchKriDetails(page = this.currentPage) {
            this.loading = true;
            this.kriList = [];

            try {
                const response = await axios.get(
                    `${this.baseurl}/forms/rbqm/paginatedkri`,
                    {
                        params: {
                            StudyId: this.studyId,
                            KriId: this.searchField.kriId || undefined,
                            CtqId: this.searchField.ctqId || undefined,
                            RiskId: this.searchField.riskId || undefined,
                            pageindex: page,
                            pagesize: this.pageSize,
                        },
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const result = response.data;

                if (result.entities && Array.isArray(result.entities)) {
                    this.kriList = result.entities.map(i => ({ ...i, expanded: false }));
                    this.totalCount = result.totalCount || 0;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (Array.isArray(result)) {
                    this.kriList = result.map(i => ({ ...i, expanded: false }));
                    this.totalCount = result.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (result) {
                    this.kriList = [{ ...result, expanded: false }];
                    this.totalCount = 1;
                    this.totalPages = 1;
                }

                this.currentPage = page;
            } catch (error) {
                console.error("Error fetching KRI details:", error);
                this.kriList = [];
                this.totalCount = 0;
                this.totalPages = 0;
            } finally {
                this.loading = false;
            }
        },

        searchReports() {
            this.currentPage = 1;
            this.fetchKriDetails();
        },

        // Registry has no parent CtQ context to prefill from, unlike
        // KriInfoModal which derives ctqId/ctqFactor/category from its
        // `data` prop. Editing still works the same either way.
        openManageKRIModal(item) {
            if (item) {
                this.riskEditData = { ...item };
            } else {
                this.riskEditData = null;
            }
            this.openCreateRiskModal = true;
        },

        closeKRIRiskModal() {
            this.openCreateRiskModal = false;
            this.riskEditData = null;
        },

        reloaddatagrid() {
            this.fetchKriDetails();
        },

        loadPage(page) {
            this.fetchKriDetails(page);
        },

        viewKriDetails(item) {
            this.selectedKriItem = item;
            this.showKriDetailsModal = true;
        },

        closeKriDetailsModal() {
            this.showKriDetailsModal = false;
            this.selectedKriItem = null;
        },

        truncate(text) {
            if (!text) return "";
            return text.length > 120 ? text.substring(0, 120) + "..." : text;
        },

        toggleExpand(item) {
            item.expanded = !item.expanded;
        },
    },
};